import { useQuery } from "@apollo/client";

import { DASHBOARDS, WorkspaceClientName } from "api/workspace";

import { WorkspaceQuery } from "models/workspace";

export default function useDashboards() {
  const query = useQuery<WorkspaceQuery>(DASHBOARDS, {
    context: {
      clientName: WorkspaceClientName
    }
    // fetchPolicy: 'no-cache', // Avoid any caching
    // notifyOnNetworkStatusChange: true // Ensure updates trigger re-renders
  });

  return query;
}
